<template>
  <div class="separator-container" :class="[alignmentClass, colorClass]">
    <div v-if="text" class="separator-line" :class="leftLineClass" :style="lineStyle"></div>
    <span v-if="text" class="separator-text" :style="textStyle">{{ text }}</span>
    <div class="separator-line" :class="rightLineClass" :style="lineStyle"></div>
  </div>
</template>

<script>
export default {
  name: "CustomSeparator",
  props: {
    text: {
      type: String,
      default: "分隔线",
    },
    alignment: {
      type: String,
      default: "center", // left, center, right
      validator: (value) => ["left", "center", "right"].includes(value),
    },
    color: {
      type: String,
      default: "primary", // 可传 "primary" 或 "#ff0000|#000000"
    },
  },
  computed: {
    alignmentClass() {
      return `${this.alignment}-align`;
    },
    leftLineClass() {
      return this.alignment === "left"
        ? "short-line"
        : this.alignment === "left-mini"
          ? "mini-line"
          : "long-line";
    },
    rightLineClass() {
      return this.alignment === "right"
        ? "short-line"
        : this.alignment === "right-mini"
          ? "mini-line"
          : "long-line";
    },
    colorParts() {
      return String(this.color || "").split("|");
    },
    bgColor() {
      return this.colorParts[0] || null;
    },
    textColor() {
      return this.colorParts.length > 1 ? this.colorParts[1] : null;
    },
    presetColors() {
      return [
        "primary",
        "secondary",
        "accent",
        "dark",
        "positive",
        "negative",
        "info",
        "warning",
      ];
    },
    colorClass() {
      return this.bgColor && this.presetColors.includes(this.bgColor)
        ? `separator-${this.bgColor}`
        : "";
    },
    lineStyle() {
      // 只在自定义颜色时加 style，预设颜色交给 CSS
      if (this.bgColor && !this.presetColors.includes(this.bgColor)) {
        return { backgroundColor: this.bgColor };
      }
      return {};
    },
    textStyle() {
      if (this.textColor) {
        return { color: this.textColor };
      }
      // 自定义颜色时文字默认 #555
      if (this.bgColor && !this.presetColors.includes(this.bgColor)) {
        return { color: "#555" };
      }
      return {};
    },
  },
};
</script>

<style scoped>
.separator-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 16px 0;
}

.separator-line {
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
  transition: all 0.3s ease;
}

.long-line {
  flex-grow: 1;
}

.short-line {
  flex-grow: 0.3;
}

.mini-line {
  flex-grow: 0.1;
}

.separator-text {
  padding: 0 16px;
  color: #555;
  font-size: 14px;
  white-space: nowrap;
}

/* 左对齐样式 */
.left-align .separator-line:first-child {
  flex-grow: 0.3;
}

.left-align .separator-line:last-child {
  flex-grow: 1;
}

/* 居中对齐样式 */
.center-align .separator-line {
  flex-grow: 1;
}

/* 右对齐样式 */
.right-align .separator-line:first-child {
  flex-grow: 1;
}

.right-align .separator-line:last-child {
  flex-grow: 0.3;
}

/* 颜色预设 */
.separator-primary .separator-line {
  background-color: #1976d2;
}

.separator-primary .separator-text {
  color: #1976d2;
}

.separator-secondary .separator-line {
  background-color: #26a69a;
}

.separator-secondary .separator-text {
  color: #26a69a;
}

.separator-accent .separator-line {
  background-color: #9c27b0;
}

.separator-accent .separator-text {
  color: #9c27b0;
}

.separator-dark .separator-line {
  background-color: #333;
}

.separator-dark .separator-text {
  color: #333;
}

.separator-positive .separator-line {
  background-color: #21ba45;
}

.separator-positive .separator-text {
  color: #21ba45;
}

.separator-negative .separator-line {
  background-color: #c10015;
}

.separator-negative .separator-text {
  color: #c10015;
}

.separator-info .separator-line {
  background-color: #31ccec;
}

.separator-info .separator-text {
  color: #31ccec;
}

.separator-warning .separator-line {
  background-color: #f2c037;
}

.separator-warning .separator-text {
  color: #f2c037;
}
</style>
